import { Col, ColType, Crud } from "../../comp/crud";
import {
  ApiClient,
  displayLeadAssignStatus,
  displayLeadStatus,
} from "../../api/ApiClient";
import "../clientConfig/index.scss";
import { LeadCurd } from "./leadCrud";

export default function Leads() {
  return <LeadCurd name="全部客户" type="all" router="leads" />;
}
